import { css } from "lit";
import { baseStyles } from "../../../theme/theme";

export const confirmationStyles = [
  baseStyles,
  css`
    :host {
      display: block;
      background: var(--zui-bg);
    }
    .wrap {
      max-width: 640px;
      margin: 0 auto;
      padding: 4rem 1.5rem 3.75rem;
      text-align: center;
    }
    .hero-check {
      width: 64px;
      height: 64px;
      border-radius: 999px;
      background: var(--zui-accent);
      display: grid;
      place-items: center;
      margin: 0 auto;
      box-shadow: 0 0 0 8px var(--zui-accent-soft);
    }
    .headline {
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 40px;
      letter-spacing: -0.02em;
      color: var(--zui-headline);
      margin: 1rem 0 0.5rem;
    }
    .receipt {
      font-size: 15px;
      color: var(--zui-panel-ink-soft);
    }
    .receipt strong {
      color: var(--zui-headline);
    }
    .card {
      text-align: left;
      background: #fff;
      border: 1px solid var(--zui-line);
      border-radius: 14px;
      padding: 1.25rem 1.375rem;
      margin: 1.75rem 0 1rem;
    }
    .card-top {
      display: flex;
      flex-wrap: wrap;
      /* A long class name wraps; pin the price to the top-right of the block
         instead of the first line's baseline, where it reads as part of the
         title. */
      align-items: flex-start;
      justify-content: space-between;
      gap: 0.75rem;
    }
    .card-title {
      min-width: 0;
      flex: 1 1 14rem;
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 20px;
      letter-spacing: -0.01em;
      color: var(--zui-headline);
    }
    .card-price {
      max-width: 100%;
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 20px;
      color: var(--zui-headline);
      white-space: normal;
      overflow-wrap: anywhere;
    }
    .card-sub {
      font-size: 13.5px;
      color: var(--zui-panel-ink-soft);
      margin-top: 0.4rem;
      line-height: 1.5;
    }
    .card-foot {
      display: flex;
      justify-content: space-between;
      gap: 0.75rem;
      margin-top: 0.875rem;
      padding-top: 0.75rem;
      border-top: 1px solid var(--zui-line);
      font-size: 12px;
      color: var(--zui-panel-ink-soft);
    }
    .cal-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-bottom: 0.625rem;
    }
    .cal-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.375rem;
      text-decoration: none;
      background: #fff;
      border: 1px solid var(--zui-line);
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.875rem 0.625rem;
      font: inherit;
      font-size: 13px;
      font-weight: 700;
      color: var(--zui-headline);
      cursor: pointer;
    }
    .wide-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      width: 100%;
      appearance: none;
      font: inherit;
      font-size: 0.9rem;
      font-weight: 600;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.875rem 1.125rem;
      cursor: pointer;
      margin-bottom: 0.625rem;
    }
    .wide-btn.soft {
      background: var(--zui-accent-soft);
      color: var(--zui-accent-deep);
      border: 1px solid var(--zui-accent);
    }
    .wide-btn.plain {
      background: #fff;
      color: var(--zui-headline);
      border: 1px solid var(--zui-line);
      margin-bottom: 1.375rem;
    }
    .setup {
      text-align: left;
      border: 1.5px dashed var(--zui-accent);
      border-radius: 14px;
      background: var(--zui-accent-soft);
      padding: 1.375rem;
    }
    .setup .h {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      font-weight: 700;
      color: var(--zui-headline);
    }
    .setup .b {
      font-size: 0.85rem;
      color: var(--zui-panel-ink-soft);
      margin: 0.3rem 0 0.875rem;
      line-height: 1.5;
    }
    .setup .cta {
      appearance: none;
      border: 0;
      cursor: pointer;
      width: 100%;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 15px;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.8rem 1rem;
    }
    .setup .cta:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    /* Why the CTA above is dead, in the visitor's words. See renderSetup(). */
    .setup-note {
      margin: 0.625rem 0 0;
      font-size: 0.78rem;
      line-height: 1.45;
      color: var(--zui-panel-ink-soft);
    }
    /* Transient "Copied!" / "Shared!" confirmation on the share button. */
    .share-btn {
      transition:
        background 160ms ease,
        border-color 160ms ease,
        color 160ms ease;
    }
    .share-btn.copied,
    .share-btn.shared {
      background: var(--zui-accent-soft);
      border-color: var(--zui-accent);
      color: var(--zui-accent-deep);
    }
    .share-btn.copied svg,
    .share-btn.shared svg {
      animation: zconf-pop 260ms cubic-bezier(0.22, 1.2, 0.4, 1);
    }
    .share-btn.failed {
      border-color: #e0bda9;
      color: #b4541f;
    }
    @keyframes zconf-pop {
      0% {
        transform: scale(0.4);
        opacity: 0;
      }
      60% {
        transform: scale(1.15);
        opacity: 1;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
    /* The icon/colour swap is invisible to screen readers, so the same state
         is written here and announced politely. */
    .share-live {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      border: 0;
      overflow: hidden;
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      white-space: nowrap;
    }
    .share-fallback {
      text-align: left;
      margin-bottom: 1.375rem;
    }
    .share-fallback input {
      width: 100%;
    }
    /* Embedded "My Account" setup modal (opened from the setup CTA). */
    .acct-overlay {
      position: fixed;
      inset: 0;
      background: rgba(20, 24, 28, 0.55);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      z-index: 2147483000;
    }
    .acct-modal {
      background: #fff;
      color: var(--zui-headline);
      width: 100%;
      max-width: 420px;
      border-radius: 16px;
      padding: 1.5rem;
      box-shadow: 0 20px 60px -20px rgba(0, 0, 0, 0.5);
      text-align: left;
    }
    .acct-modal h3 {
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 1.2rem;
      margin: 0 0 0.25rem;
      color: var(--zui-headline);
    }
    .acct-sub {
      font-size: 0.85rem;
      color: var(--zui-panel-ink-soft);
      line-height: 1.45;
      margin-bottom: 1rem;
    }
    .acct-field {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      font-size: 0.75rem;
      font-weight: 600;
      color: var(--zui-panel-ink-soft);
      margin-bottom: 0.6rem;
    }
    .acct-field input {
      border: 1.5px solid var(--zui-line);
      border-radius: 10px;
      padding: 0.6rem 0.7rem;
      font: inherit;
      font-size: 15px;
      color: var(--zui-headline);
      background: var(--zui-panel);
    }
    .acct-field input:focus {
      outline: none;
      border-color: var(--zui-accent);
      box-shadow: 0 0 0 3px var(--zui-accent-soft);
    }
    .acct-actions {
      display: flex;
      gap: 0.6rem;
      margin-top: 0.5rem;
    }
    .acct-save {
      flex: 1;
      appearance: none;
      border: 0;
      cursor: pointer;
      background: var(--zui-accent);
      color: var(--zui-btn-text);
      font-family: var(--zui-font);
      font-weight: 700;
      font-size: 15px;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.8rem 1rem;
    }
    .acct-save:disabled {
      opacity: 0.55;
      cursor: default;
    }
    .acct-cancel {
      appearance: none;
      background: none;
      border: 1px solid var(--zui-line);
      color: var(--zui-headline);
      cursor: pointer;
      font: inherit;
      font-weight: 600;
      border-radius: var(--zui-btn-radius, 10px);
      padding: 0.8rem 1rem;
    }
    .acct-done {
      display: grid;
      place-items: center;
      gap: 0.5rem;
      text-align: center;
      padding: 0.25rem 0;
    }
    /* Own row ABOVE the actions. It used to sit between Cancel and Create
         account, where a full sentence was squeezed into a few characters of
         gap and read as a button label. */
    .acct-error {
      font-size: 0.8rem;
      line-height: 1.45;
      color: #b4541f;
      background: #fdf1ea;
      border: 1px solid #f0cdb8;
      border-radius: 10px;
      padding: 0.5rem 0.625rem;
      margin: 0.25rem 0 0;
    }
    @media (max-width: 700px) {
      .headline {
        font-size: 30px;
      }
      /* Tighten the stacked label under the calendar/booking link icons. */
      .cal-btn {
        line-height: 1.15;
      }
      .wide-btn {
        line-height: 1.25;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      .share-btn,
      .share-btn.copied svg,
      .share-btn.shared svg {
        transition: none;
        animation: none;
      }
    }
  `,
];
